import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../../assests/i18n/i18n';
import AppRoutes from './App.routes';
import Seo from '../../seo/Seo';
import '../../App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function App() {
  const location = useLocation();
  useEffect(() => {
    const frame = window.requestAnimationFrame(() => {
      let id = location.hash.slice(1);
      try { id = decodeURIComponent(id); } catch { /* Ignore malformed URL fragments. */ }
      const target = id ? document.getElementById(id) : null;
      if (target) target.scrollIntoView({ behavior: 'auto', block: 'start' });
      else window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname, location.hash, location.key]);
  return <><Seo /><AppRoutes /></>;
}